// eslint-disable
import PARSE from "html-react-parser";
import React, { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import store from "../../context/store";
import Api from "./Api";

const api = new Api();

export default function SSoft_Hero_Side() {
  const dispatch = useDispatch();
  const activeLanguage = useSelector((state) => state.content.activeLanguage);
  const [sections, setSections] = useState([]);

  const [loaded, setLoaded] = useState(false);
  const [background, setBackground] = useState("");
  const [backgroundSmall, setBackgroundSmall] = useState("");
  const [boxContent, setBoxContent] = useState(null);
  const [listButton, setListButton] = useState(null);

  useEffect(() => {
    const getSectionDetail = () => {
      api
        .getSectionDetail({ language: activeLanguage })
        .then((res) => {
          if (res === 200 || res.data) {
            setSections(res.data.results);
          }
        })
        .catch((err) => {
          console.log("~ err", err);
        });
    };

    getSectionDetail();
  }, [activeLanguage]);

  useEffect(() => {
    let switchCaseCompleted = 0;

    if (sections.length > 0) {
      const sec = sections[0]?.widgets;
      if (sec && sec.length !== 0) {
        sec.forEach((section, i) => {
          switch (i) {
            case 0: {
              setBackground(
                section?.widget_contents[0]?.file_big ||
                  section?.widget_contents[0]?.file
              );
              setBackgroundSmall(
                section?.widget_contents[0]?.asset_mobile ||
                  section?.widget_contents[0]?.file
              );
              break;
            }
            case 1: {
              setBoxContent(section?.widget_contents[0]);
              break;
            }
            case 2: {
              setListButton(section?.widget_contents);
              break;
            }
            default:
              break;
          }

          switchCaseCompleted++; // Increment the switch case completion counter
        });

        if (switchCaseCompleted === 3) {
          setLoaded(true); // Set loaded to true after all switch cases have completed
        }
      }
    }
  }, [sections]);

  return loaded ? (
    // <div className="mt-[78px] lg:mb-0 s:mb-[350px] mb-[450px]">
    <div className="mt-[78px] s:!mb-0 mb-[250px] tall:mb-[260px] short:mb-[250px]">
      <div className=" hd2xl:max-h-[1000px] lg:max-h-[800px] md:max-h-[600px] md:h-[630px] s:h-[60vh] s:max-h-[630px]  max-h-[400px]  h-[75vh] relative bg-[#FAF8F5]">
        <div className="xl:w-6/12 w-full s:block hidden  h-full top-0 absolute right-0">
          {/* <img
            height="auto"
            width="auto"
            src={background}
            className="w-full h-full object-cover object-top "
          /> */}

          <picture className="h-full w-full">
            <source
              media="(max-width: 576px)"
              srcSet={backgroundSmall}
              sizes="576px"
              height="auto"
              width="auto"
              src={background}
              fetchpriority="high"
              alt={boxContent?.article_language?.title}
              className="w-full h-full object-cover object-top "
            />
            <source srcSet={background} sizes="100vw" />
            <img
              height="auto"
              width="auto"
              src={background}
              fetchpriority="high"
              alt={boxContent?.article_language?.title}
              className="w-full h-full object-cover object-top "
            />
          </picture>
        </div>
        {/* <img
          height="auto"
          width="auto"
          src={background}
          fetchpriority="high"
          alt={boxContent?.article_language?.title}
          className="s:hidden block absolute left-0 top-0 w-full hd2xl:max-h-[1000px] lg:max-h-[800px] md:max-h-[600px] md:h-[630px] s:h-[60vh] s:max-h-[630px]  max-h-[400px]  h-[75vh] object-cover object-top  "
        /> */}

        <picture className="h-full w-full">
          <source
            media="(max-width: 576px)"
            srcSet={backgroundSmall}
            sizes="576px"
            height="auto"
            width="auto"
            src={background}
            fetchpriority="high"
            alt={boxContent?.article_language?.title}
            className="s:hidden block absolute left-0 top-0 w-full hd2xl:max-h-[1000px] lg:max-h-[800px] md:max-h-[600px] md:h-[630px] s:h-[60vh] s:max-h-[630px]  max-h-[400px]  h-[75vh] object-cover object-top  "
          />
          <source srcSet={background} sizes="100vw" />
          <img
            height="auto"
            width="auto"
            src={background}
            fetchpriority="high"
            alt={boxContent?.article_language?.title}
            className="s:hidden block absolute left-0 top-0 w-full hd2xl:max-h-[1000px] lg:max-h-[800px] md:max-h-[600px] md:h-[630px] s:h-[60vh] s:max-h-[630px]  max-h-[400px]  h-[75vh] object-cover object-top  "
          />
        </picture>
        <div className="s:!block hidden  hd2xl:max-h-[1000px] lg:max-h-[800px] md:max-h-[600px] md:h-[630px] s:h-[60vh] s:max-h-[630px]  max-h-[400px]  h-[75vh] w-full bg-[#FAF8F5] ">
          <div className="section-container section-margin-x h-full flex flex-col items-start justify-center -smt-[50px]">
            <div className=" w-fit fhd:max-w-[600px] hd:max-w-[550px] mdl:max-w-[500px]  md:max-w-[530px] s:max-w-[400px] max-w-[320px] hd:-mt-[200px] -mt-[130px]">
              {/* <h1 className="text-[21px] font-[500] leading-[100%] ">
                {boxContent?.article_language?.title}
              </h1> */}
              <h2 className="header-style-hero  text-[#0D4052] pdt-[30px]">
                {boxContent?.article_language?.summary}
              </h2>
              <div className="subheader-style-hero pt-[25px] ">
                {PARSE(boxContent?.article_language?.content)}
              </div>
              <div className="pt-[30px] s:space-x-[15px] s:space-y-[0px] space-y-[15px] flex s:flex-row flex-col">
                <Link
                  to={listButton[0]?.article_language?.path || "/"}
                  className=""
                >
                  <div
                    onClick={() => {
                      const segments = sections[0].page_url
                        .replace(/^\/|\/$/g, "")
                        .split("/");

                      // Extract the last segment and replace dashes with spaces
                      const resultSolution = segments[segments.length - 1]
                        .replace(/-/g, " ")
                        .replace(/\b\w/g, (char) => char.toUpperCase());
                      store.dispatch({
                        type: "topicStore/setTopicAndSolution",
                        payload: { solutionOptionValue: resultSolution },
                      });
                    }}
                    className=" all-button bg-[#E12726] "
                  >
                    {listButton[0]?.article_language.title}
                  </div>
                </Link>
                {listButton.length > 1 && (
                  <Link
                    to={listButton[1]?.article_language?.path || "/"}
                    className=""
                  >
                    <div className="flex items-center justify-center h-[48px]  hd:px-[25px] text-center md:px-[17px]  md:px-[13px] px-[8px] font-inter bg-[#0D4052] rounded-[8px] text-white s:w-fit font-semibold leading-[20px]">
                      {listButton[1]?.article_language.title}
                    </div>
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="xl:!hidden block absolute z-10 inset-0  hd2xl:max-h-[1000px] lg:max-h-[800px] md:max-h-[650px] md:h-[645px] s:h-[70vh] s:max-h-[480px]  max-h-[400px]  h-[75vh] w-full ">
          <div className="section-container section-margin-x h-full w-full flex flex-col items-start justify-center s:relative absolute s:translate-x-0 s:left-0  left-1/2 -translate-x-1/2  md:!bottom-[30px] s:-bottom-[50px] -bottom-[220px] short:-bottom-[160px] tall:-bosttom-[240px]  ">
            <div className="bg-[#FAF8F5] hd2xl:p-[55px] s:p-[45px] p-[25px] w-fit hd2xl:max-w-[600px] hd:max-w-[550px] mdl:max-w-[590px] md:max-w-[470px] s:max-w-[470px] max-w-[100vw] h-fit s:shadow-none shadow-xl">
              {/* <h1 className="hd:prose-p:text-[55px] hd2xl:prose-p:text-[59px] mdl:prose-p:text-[42px] prose-p:text-[32px]  prose-p:leading-[115%] text-[#0D4052] font-dmsans-bold max-w-[450px]">
                {PARSE(boxContent?.article_language?.content)}
              </h1> */}
              {/* <h1 className="text-[21px] leading-[100%] ">
                {boxContent?.article_language?.title}
              </h1> */}
              {/* <h1 className="text-[21px] font-[500] leading-[100%] ">
                {boxContent?.article_language?.title}
              </h1> */}
              <h2 className="header-style-hero text-newDarkBlue pdt-[30px] ">
                {boxContent?.article_language?.summary}
              </h2>
              {/* <h2 className="hd2xl:text-[22px] text-[18px] pt-[25px] leading-[115%] font-inter">
                {boxContent?.article_language?.summary}
              </h2> */}
              <div className="pt-[25px]">
                {PARSE(boxContent?.article_language?.content)}
              </div>
              <div className="pt-[30px] space-x-[15px]  flex flex-row ">
                <Link
                  to={listButton[0]?.article_language?.path || "/"}
                  className=""
                  onClick={() =>
                    store.dispatch({
                      type: "topicStore/setTopicValue",
                      payload: "General",
                    })
                  }
                >
                  <div className="hd2xl:text-[22px] s:text-[16px] text-[12px] flex items-center justify-center hd2xl:h-[56px] h-[48px]  hd:px-[25px]  px-[18px] font-inter bg-[#E12726] rounded-[8px] text-white s:w-fit font-semibold leading-[20px]">
                    {listButton[0]?.article_language.title}
                  </div>
                </Link>

                {listButton.length > 1 &&
                listButton[1]?.assets[0]?.asset_file ? (
                  <Link
                    to={listButton[1]?.article_language?.path || "/"}
                    className=""
                  >
                    <div className="hd2xl:text-[22px] s:text-[16px] text-[12px] flex s:space-x-[16px] space-x-[6px] border items-center justify-center hd2xl:h-[56px] h-[48px]  hd:px-[25px] text-center px-[18px] font-inter text-[#0D4052] rounded-[8px] bg-white s:w-fit font-semibold leading-[20px]">
                      <img
                        src={listButton[1]?.assets[0]?.asset_file}
                        alt={listButton[1]?.assets[0]?.description}
                        className=""
                      />
                      <div className="">
                        {listButton[1]?.article_language.title}
                      </div>
                    </div>
                  </Link>
                ) : (
                  listButton.length > 1 && (
                    <Link
                      to={listButton[1]?.article_language?.path || "/"}
                      className=""
                    >
                      <div className=" hd2xl:text-[22px] s:text-[16px] text-[12px] flex items-center justify-center hd2xl:h-[56px] h-[48px]  hd:px-[25px] text-center px-[18px] font-inter bg-[#0D4052] rounded-[8px] text-white s:w-fit font-semibold leading-[20px]">
                        {listButton[1]?.article_language.title}
                      </div>
                    </Link>
                  )
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <Skeleton
      width={"100%"}
      className="!z-[100] fhd:!h-[calc(60vh+78px)] md:!h-[calc(630px+78px)] h-[calc(60vh+78px)]"
    />
  );
}
